import React, { useEffect, useState } from "react";
import DemoInterestedSection from "../../Component/DemoInterestedSection";
import OnePlatformSection from "./component/OnePlatformSection";
import OurStoryMissionSection from "./component/OurStoryMissionSection";
import HomeInformationSection from "./component/HomeInformationSection";
import IntroducingSection from "./component/IntroducingSection";
import MainBannerSection from "./component/MainBannerSection";

function HomePage() {
  const [acfData, setAcfData] = useState(null);
  const onRefresh = async () => {
    try {
      const response = await fetch("https://www.lagunacreek.io/blog/wp-json/custom/v1/acf-data/front-end-home-page");

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const source = await response.json();
      const acf_fields = source?.acf_fields;
      setAcfData(acf_fields)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
    onRefresh()
  }, []);

  return (
    <>
      <MainBannerSection acfData={acfData}  />
      <IntroducingSection acfData={acfData} />
      <OurStoryMissionSection acfData={acfData} />
      <HomeInformationSection acfData={acfData} />
      <OnePlatformSection acfData={acfData} />
      <DemoInterestedSection acfData={acfData} />
    </>
  );
}

export default HomePage;
